export default __webpack_public_path__ + "static/media/sky-building.785eeafc.png";